import {PureComponent} from 'react'
import PropTypes from 'prop-types'
import {CardHeader, Badge} from 'reactstrap'
import AlertCircle from 'react-feather/dist/icons/alert-circle.js'
import Tooltip from 'rc-tooltip'

import conf from '../../../../conf.js'
import {getPercent} from '../../../../services/stepService.js'

const universes = ['Aucun', 'Achats & Supply', 'Finance', 'Ressources Humaines', 'Ingénierie']
export default class Labels extends PureComponent {
  static propTypes = {
    freelance: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    isCard: PropTypes.bool,
    withUniverse: PropTypes.bool,
    className: PropTypes.string
  }

  static defaultProps = {
    className: '',
    withUniverse: false
  }

  render() {
    const { user, freelance, isCard, withUniverse, className } = this.props
    const isGray = user?.gray
    const hasEmail = user?.email

    if (isGray && !hasEmail && user?.old_email) {
      return (
        <div className={["d-flex justify-content-center align-items-center", className].join(' ')}>
          <Badge className={className} color="danger">Supprimé</Badge>
        </div>
      )
    }

    const badges = [
      { condition: user?.universes?.[0] && withUniverse, badge: { color: 'secondary', message: universes[user?.universes?.[0] || 0] } },
      { condition: !!user?.meeting && !user?.complete, badge: { color: 'info', message: 'RDV planifié' } },
      { condition: !user?.complete, badge: { color: 'warning', message: `Non complet ${getPercent(user)}%` } },
      { condition: hasEmail && isGray, badge: { color: 'primary', message: 'Importé' } },
      { condition: user?.unreliable, badge: { color: 'danger', message: 'Douteux' } },
      { condition: freelance?.no_show, badge: { color: 'danger', message: 'No show' } },
      { condition: freelance?.cdi, badge: { color: 'warning', message: 'En CDI' } },
      { condition: user?.isProgessiActive, badge: { color: 'success', message: 'En mission' } },
      { condition: !freelance?.public, badge: { color: 'dark', message: 'Masqué' } }
    ].filter(rule => rule.condition).map(rule => rule.badge)

    const hasNoWorkPermit = (conf.workPermits.noAuthorization.value === freelance?.work_permit) ?? conf.workPermits.noAuthorization.value

    if (!badges.length && !hasNoWorkPermit) return ''

    const content = (
      <div className={["d-flex justify-content-center align-items-center", className].join(' ')}>
        {badges.map((badge, index) => (
          <Badge key={index} color={badge.color} className="mx-1">{badge.message}</Badge>
        ))}
        {hasNoWorkPermit && (
          <Tooltip placement="bottom" overlay="Pas d'autorisation de travail">
            <AlertCircle fill="red" color="white" />
          </Tooltip>
        )}
      </div>
    )

    return isCard ? <CardHeader>{content}</CardHeader> : content
  }
}
